import React, { ReactElement } from 'react';
import { Loader } from 'idsk-react-components';
import SubjektBezPripomienokListTable
  from './component/SubjektBezPripomienokListTable/SubjektBezPripomienokListTable';
import SubjektBezPripomienokListPage
  from '../../model/subjektbezpripomienok/SubjektBezPripomienokListPage';
import { ClientStatus } from '../../model/ClientStatus';

interface Props {
  page: SubjektBezPripomienokListPage;
  status: ClientStatus
  pageNumberFromUrl: number;

  reloadSubjektBezPripomienokList(): void;
}

const SubjektBezPripomienokList = ({
  page,
  status,
  pageNumberFromUrl,
  reloadSubjektBezPripomienokList,
}: Props): ReactElement => (
  <Loader loading={status.loading}>
    <SubjektBezPripomienokListTable
      subjektPage={page}
      pageNumberFromUrl={pageNumberFromUrl}
      reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
    />
  </Loader>
);

export default SubjektBezPripomienokList;
